module.exports = __webpack_public_path__ + "static/media/Icon-envelope-closed.6ee61364.svg";